import type { initialSearchStateType } from "src/reducks/SearchStore/types";

export const initialSearchState: initialSearchStateType = {
  search: "",
  toggleSearch: false,
};
